import * as React from 'react';
import { CircularProgress } from '@mui/material';

import { Message } from './Message';

export const Uploading: React.FC = () => (
  <Message>
    <div className="flex flex-col items-center space-y-4">
      <CircularProgress size={60} />
      <h1 className="mb-4">Your file is uploading...</h1>
      <p>This might take a couple of minutes, hang tight!</p>
    </div>
  </Message>
);
Uploading.displayName = 'Uploading';
